module.exports = __webpack_public_path__ + "img/send_icon.3435c453.svg";